import { Link } from 'react-router-dom';
import { CardSkeleton } from '@/components/common/CardSkeleton';
import { useGetFixtureCountsQuery } from '@/store/api/fixtureApi';
import { useParlay } from '@/hooks/useParlay';

const sports = [
  {
    title: 'All',
    href: '/sports/all',
  },
  {
    title: 'Cricket',
    href: '/sports/cricket',
  },
  {
    title: 'Soccer',
    href: '/sports/soccer',
  },
  {
    title: 'Tennis',
    href: '/sports/tennis',
  },
];

interface SportsCardsProps {
  type: 'inplay' | 'today' | 'tomorrow';
}

const sportImages: Record<string, string> = {
  all: '/images/sports/all.jpg',
  cricket: '/images/sports/cricket.jpg',
  soccer: '/images/sports/soccer.jpg',
  tennis: '/images/sports/tennis.jpg',
};

export default function SportsCards({ type }: SportsCardsProps) {
  const { isParlayEnabled } = useParlay();
  const { data, isLoading } = useGetFixtureCountsQuery(
    { isParlay: isParlayEnabled },
    { pollingInterval: 5000 }
  );
  const counts = data?.counts[type];

  if (isLoading) {
    return <CardSkeleton length={4} />;
  }
  return (
    <div className="flex-1 space-y-2">
      {sports.map(({ title, href }) => {
        const image = sportImages[title.toLowerCase()] ?? '/images/sports/default.jpg';
        const count = (title === 'All' ? counts?.all : counts?.sports?.[title]) ?? 0;

        return (
          <Link
            key={`${type}-${title}`}
            to={`${href}/${type}`}
            style={{
              backgroundImage: `url(${image})`,
            }}
            className="block relative h-[7.375rem] overflow-hidden rounded-2xl bg-cover bg-center bg-no-repeat"
          >
            <div className="relative z-10 flex h-full flex-col justify-center pl-6">
              <p className="text-[1.125rem] font-semibold text-[#4b5563]">{title}</p>

              <h2 className="text-[3.625rem] font-extrabold leading-none text-[#111827]">
                {count}
              </h2>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
